import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import { isSpaLink, stripHost } from 'tradera-utils/url';
import { useUrlLocalizer } from 'tradera-lang/translate';
import { getImageSizes, getWebpImage } from '../image-sizes';
import { trackContainerClick } from '../analytics';
import MediaItem from '../media/media-item';
import ALink from 'tradera-components/alink/alink';

const CarouselItem = ({
    containerType,
    inSPA,
    item,
    itemCount,
    videoEnabled
}) => {
    const {
        alternativeText,
        body,
        image,
        webpageUrl,
        heading,
        button,
        showHeading,
        trackingId,
        video
    } = item;
    const { toLocalizedUrl } = useUrlLocalizer();

    const showContent = showHeading || button || body;
    const imageSizes = getImageSizes(itemCount, image, containerType);
    const webpImage = getWebpImage(itemCount, image, containerType);
    const url = stripHost(toLocalizedUrl(webpageUrl));

    return (
        <>
            <div className="carousel-item-media-wrapper">
                <div className="carousel-item bg-gray-300">
                    <ALink
                        useLink={inSPA && isSpaLink(url)}
                        aria-label={alternativeText || heading}
                        href={url}
                        onClick={() =>
                            trackContainerClick(containerType, trackingId)
                        }
                        className="carousel-item-link">
                        <LazyLoad offset={100} once>
                            <MediaItem
                                alternativeText={alternativeText}
                                heading={heading}
                                imageSizes={imageSizes}
                                image={image}
                                video={videoEnabled ? video : null}
                                webpImage={webpImage}
                            />
                        </LazyLoad>
                    </ALink>
                </div>
            </div>
            {showContent && (
                <div className="carousel-item-content-wrapper">
                    {showHeading && (
                        <h2 className="text-dark text-styled">{heading}</h2>
                    )}
                    {body && <p className="text-styled">{body}</p>}
                    {button && (
                        <ALink
                            useLink={inSPA && isSpaLink(url)}
                            aria-label={alternativeText || heading}
                            href={url}
                            onClick={() =>
                                trackContainerClick(containerType, trackingId)
                            }
                            className="font-weight-bold btn btn-tertiary mt-1 text-styled">
                            {button}
                        </ALink>
                    )}
                </div>
            )}
        </>
    );
};

CarouselItem.propTypes = {
    item: PropTypes.shape({
        alternativeText: PropTypes.string,
        imageUrl: PropTypes.string,
        webpageUrl: PropTypes.string,
        heading: PropTypes.string,
        button: PropTypes.string,
        showsTitle: PropTypes.bool,
        video: PropTypes.object
    })
};

export default CarouselItem;
